import React from "react";
import classNames from "classnames";
import "./button.css";

const Button = (props) => {
  const { children, className, electro, ...buttonProps } = props;
  return (
    <button
      {...buttonProps}
      className={classNames("btn", className, { electro: electro })}
    >
      {children}
    </button>
  );
};

export default Button;
